import { render, staticRenderFns } from "./option-group.vue?vue&type=template&id=daa5f804&"
import script from "./option-group.vue?vue&type=script&lang=js&"
export * from "./option-group.vue?vue&type=script&lang=js&"
import style0 from "./option-group.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/gitlab-runner/builds/X4KPpxnC/0/feng.chen/site-cms/site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('daa5f804')) {
      api.createRecord('daa5f804', component.options)
    } else {
      api.reload('daa5f804', component.options)
    }
    module.hot.accept("./option-group.vue?vue&type=template&id=daa5f804&", function () {
      api.rerender('daa5f804', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/select/option-group.vue"
export default component.exports